<span class="sr-only" aria-live="polite" role="status">{{ loadingMessage }}</span>

<div class="content-div" *ngIf="questions && questions.length > 0 && questNo < questions.length">
  <div class="container">
    <h1 class="sr-only">Scenario {{ questNo + 1 }} of {{ totalQuestions }}</h1>
    <app-question-card 
      [questNo]="questNo"
      (updateQuestionEmitter)="updateQuestion()"
    ></app-question-card>
  </div>
  <div class="bottom-bar">
    <app-progress-bar 
      [questNo]="questNo"
      [totalQuestions]="totalQuestions"
    ></app-progress-bar>

    <button
      mat-flat-button
      type="button"
      class="continue-btn button-primary-focus"
      (click)="onContinueBtnClick()"
    >
      Continue
    </button>
  </div>
</div>

<div *ngIf="!questions || questions.length === 0" class="loading-div" aria-hidden="true">
  Loading...
</div>